import React, {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';
import * as S from './video.styles';

interface VideoProps {
  videoUrl: string;
  onPlay?: () => void;
  effectCallback?: () => void;
  isAutoPlay?: boolean;
  isTriggerOnLoaad?: boolean;
  onFullScreen?: () => void;
  onVolumechange?: () => void;
}

const defaultEffectCallback = () => {};

export const Video: React.FC<VideoProps> = ({
  videoUrl,
  onPlay = defaultEffectCallback,
  effectCallback = defaultEffectCallback,
  isAutoPlay,
  isTriggerOnLoaad = false,
  onFullScreen = defaultEffectCallback,
  onVolumechange = defaultEffectCallback,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!videoUrl && (!videoRef || !videoRef.current)) {
      return;
    }
    effectCallback();
    if (isTriggerOnLoaad) {
      videoRef.current?.load(); // This is added to trigger a load event for the video element whenever there's a new URL
    }

    videoRef.current?.addEventListener('play', onPlay);

    videoRef.current?.addEventListener('webkitfullscreenchange', onFullScreen);

    videoRef.current?.addEventListener('volumechange', onVolumechange);

    return () => {
      videoRef.current?.removeEventListener('play', onPlay);
    };
  }, [videoUrl]);

  return (
    <S.VideoContainer>
      {/* @Note #t=0.001 & preload="metadata" are used for ios thumbnail show as it is off by default in ios to save bandwidth
      Also playsInline is to make sure video plays inline not in full screen mode once user plays it in ios. */}
      <S.Video
        ref={videoRef}
        preload="metadata"
        playsInline
        autoPlay={isAutoPlay}
        muted
        controls={true}
      >
        <source src={`${videoUrl}${isAutoPlay ? '' : '#t=0.001'}`} type="video/mp4"></source>
      </S.Video>
    </S.VideoContainer>
  );
};
